import { Stack, Typography } from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { FileRejection } from "react-dropzone";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";
import DropzoneBtn from "./DropzoneBtn";
import FileRow from "./FileRow";
import TitleLabel from "./TitleLabel";

export default function LogoSelector() {
	const [dropError, setDropError] = useState(false);

	const { actions, values } = useContext(Context);

	const { translate } = useLocales();

	const handleDrop = useCallback((acceptedFiles: any[], fileRejections: FileRejection[]) => {
		if (fileRejections.length > 0 && fileRejections[0].errors[0].code === "file-too-large") {
			setDropError(true);
			actions.setValue("file", undefined);
		} else {
			setDropError(false);
			actions.setValue("file", acceptedFiles[0]);
		}
	}, []);

	return (
		<Stack>
			<Stack flexDirection={"row"} alignItems={"center"} justifyContent='space-between'>
				<TitleLabel />
				<DropzoneBtn onDrop={handleDrop} />
			</Stack>
			{values.file && !dropError && <FileRow />}
			{dropError && (
				<Typography variant='body2' color='error.main' sx={{ mt: 2 }}>
					{translate("logo_selector.too_big")}
				</Typography>
			)}
		</Stack>
	);
}
